<template>
  <div>
    <h5>Pickup</h5>

    <div class="vx-row">
        <div class="vx-col w-full">
            <vx-card class="mt-4">
                <div class="my-6">
                    <feather-icon icon="CheckIcon" svgClasses="h-8 w-8 text-success" class="float-right" />
                    <h5 class="mb-2">RM 0.00</h5>
                    <p class="text-grey">Self Pickup (Free)</p>
                </div>
                <vs-divider></vs-divider>
                <v-select :options="locationOptions" :clearable="false" v-model="locationMethod" class="mt-4"/>
                <div class="mt-4">
                    <p >123, Jalan Matsuri 1, Matsuri Bintang, Pulau Pinang <a><feather-icon icon="MapPinIcon" svgClasses="h-4 w-4"/></a></p>
                    <p class="text-grey">Working Hour: 10:00am to 8:00pm (closed on Sunday)</p>
                </div>
            </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data(){
    return {
      locationMethod: { label: 'Pick your location', value: '' },
      locationOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ]
    }
  }
}
</script>